import React, {useCallback} from "react";
import {useSelector, useDispatch} from "react-redux";
import {TextDetail, SecondaryButton} from "../components/UIkit";
import {getUsername} from "../reducks/users/selectors"
import {push} from "connected-react-router";

const UserMypage = () => {
    const selector = useSelector((state) => state);
    const username = getUsername(selector);
    const dispatch = useDispatch();

    const transition = useCallback((path) => {
        dispatch(push(path))
    }, []);

    return(
        <section className="c-section-container">
            <h2 className="u-text_headline u-text-center">マイページ</h2>
            <div className="module-spacer--medium" />
            <TextDetail label="ユーザー名" value={username} />
            <div className="module-spacer--medium" />
            <div className="center">
                <SecondaryButton label={"カード情報の確認"} onClick={() => transition("../user/payment/edit")} />
                <SecondaryButton label={"注文履歴"} onClick={() => transition("../order/history")} />
            </div>
        </section>
    )
}

export default UserMypage